import * as React from 'react';
import { observer } from 'mobx-react';
import { Fragment } from '../../Shared/components/fragment';
import { StepPillar } from './components/step-pillar';
import { VideoContainer } from './components/video-container';
import { classNames } from '../../Shared/utils/classnames';
import { ResourceCenterStep } from '../loggedinweb-generated';
import { ResourceCenterDashboardViewModel } from './resource-center-dashboard-view-model';
import * as styles from './resource-center-dashboard.less';

export const ResourceCenterDashboard = observer(({ vm }: { vm: ResourceCenterDashboardViewModel }) => (
	<Fragment>
		<h1>Resource Center</h1>
		<p className="lead">
			<strong>Welcome!</strong> We're glad you've chosen to partner with Pushpay and can't wait to serve you and
			your church!
		</p>
		<p className="lead">
			Below is some great information that has helped churches across the nation be successful with Pushpay.
		</p>
		<StepContainer steps={vm.model.FiveSteps} />
		<div className={styles.container}>
			<LetterPanel userName={vm.model.UserName} />
			<Videos />
		</div>
	</Fragment>
));

const StepContainer = observer(({ steps }: { steps: ResourceCenterStep[] }) => (
	<div className={styles.stepContainer}>
		{steps.map((step) => (
			<StepPillar key={step.Title} step={step} />
		))}
	</div>
));

const LetterPanel = observer(({ userName }) => (
		<div className={classNames('panel', 'panel-default', styles.letterContainer)}>
			<h2 className={classNames('panel-heading', styles.panelHeading)}>A MESSAGE FROM OUR CEO</h2>
			<div className="panel-body">
				{/* tslint:disable max-line-length */}
				<p>
					Dear {userName},
				</p>
				<p>
					Welcome to Pushpay! We’re honored to be a part of your mission.
				</p>
				<p>
					At Pushpay, we exist to serve churches like yours. Our technology is designed with a clear purpose: to
					help people connect with people. Because when people feel known, they connect more deeply with their
					church, with one another, and with their faith.
				</p>
				<p>
					You’ve joined a community of thousands of churches using Pushpay and Resi to strengthen relationships,
					simplify operations, and support meaningful engagement across every touchpoint. Whether you're a pastor,
					administrator, executive leader, or part of the tech team, we're here to equip you with the tools and
					support you need to serve your community more effectively.
				</p>
				<p>
					As you begin exploring your new software, know that you’re not alone. You’ll find a robust library of
					materials in our Resource Center, and in Pushpay University, which are built to empower your team to get
					the most out of your investment from day one. Our award-winning customer success team is also here to
					guide you every step of the way. As past ministry leaders or volunteers themselves, the majority of them
					have walked in your shoes. They're here to guide you every step of the way — from onboarding to training
					and beyond.
				</p>
				<p>
					We’re grateful to partner with you and are inspired by the work you do. Thank you for allowing us to
					support your ministry.
				</p>
				<p>With appreciation,</p>
				<img alt="Signed Kenny Wyatt" className={styles.signature} src={signatureUrlKennyW} />
				<p><strong>Kenny Wyatt</strong></p>
				<p>CEO, Pushpay</p>
				{/* tslint:disable max-line-length */}
			</div>
			<h2 className={classNames('panel-heading', styles.panelHeading)}>{legalTitle}</h2>
			<div className={classNames('panel-body', styles.panelGuarantee)}>
				<a href={legalUrl} target="_blank" rel="noopener noreferrer">
					<strong>{legalText}</strong>
				</a>
			</div>
		</div>
));

const Videos = observer(() => (
	<div className={styles.videoContainer}>
		<h3 className={styles.videoHeader}>Related videos</h3>
		{videos.map((video) => (
			<VideoContainer key={video.title} {...video} />
		))}
	</div>
));

const videos = [
	{
		title: 'Give Like God Gives - Mother Teresa',
		url: 'https://player.vimeo.com/video/183889546?color=1269a6&title=0&byline=0&portrait=0',
	},
	{
		title: 'Give Like God Gives - Bono on Generosity',
		url: 'https://player.vimeo.com/video/143070110?color=1269a6&title=0&byline=0&portrait=0',
	},
	{
		title: 'Give Like God Gives - Sarah Thebarge How Generosity Heals Us',
		url: 'https://player.vimeo.com/video/149342349?color=1269a6&title=0&byline=0&portrait=0',
	},
];

const [legalTitle, legalText, legalUrl, signatureUrlKennyW] = [
	'Legal Center',
	"Here's where you'll find all the legal information for our products, services and websites.",
	'https://pushpay.com/legal-center/portal',
	'https://downloads.pushpay.com/pushpay-app/merchant-resources/church-resources/ResourceCenter/KennyW_Signature.png',
];
